import Vue from 'vue'
import VueRouter from 'vue-router'
import lanhu_guanwangshouye from '../views/lanhu_guanwangshouye/index.vue'

Vue.use(VueRouter)

const routes = [
    {
    path: '/',
    redirect: "/index"
  },
  {
    path: '/index',
    name: 'index',
    component: lanhu_guanwangshouye
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
